function blogPath(siteTag, path = '', title = '') {
  let blogLink = '';

  const chineseCharSet =
    /[\u4E00-\u9FCC\u3400-\u4DB5\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\ud840-\ud868][\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|[\ud86a-\ud86c][\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d]/;
  let isChinese = false;

  switch (siteTag) {
    case 'site:everplate':
      blogLink = '/id/blog';
      break;

    case 'site:kitchenbase':
      blogLink = '/magazine';
      break;

    case 'site:freshlane':
      isChinese = chineseCharSet.test(title.toString());

      if (isChinese) blogLink = '/zh/blog';
      else blogLink = '/en/blog';
      break;

    default:
      blogLink = '/blog';
      break;
  }

  if (path === '') return `${blogLink}/`;

  if (path.toString().includes('/yue')) path = path.replace('/yue/', '/');
  if (path.toString().includes('/zh-hans'))
    path = path.replace('/zh-hans/', '/');

  if (path[0] === '/') return `${blogLink}${path}`;

  return `${blogLink}/${path}`;
}

module.exports = { blogPath };
